import {
    get_tipiIncasso,
    create_tipoIncasso,
    update_tipoIncasso,
    duplica_tipoIncasso,
    delete_tipoIncasso,
} from "@/api/api.tipoincasso.js";

const tipiIncasso = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_tipiIncasso().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati }) {
            const call = id ? update_tipoIncasso(id, dati) : create_tipoIncasso(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                delete_tipoIncasso(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        duplica({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                duplica_tipoIncasso(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default tipiIncasso;
